const menuFormatter = (data = {}) => {
  const slots = Object.keys(data);
  if (!slots.length) return {};
  return slots.reduce((acc, slot) => {
    acc[slot] = menuItemsRecursion(data[slot]?.desktop?.items || []);
    return acc;
  }, {});
}

const menuItemsRecursion = (items = []) => {
  if (items.length && !!items[0] && Array.isArray(items[0])) {
    return items.map(menuItemsRecursion);
  }
  return items.map(i => {
    if (!!i.length && Array.isArray(i)) {
      return i.map(menuItemsRecursion);
    }
    if (i.type === 'common') {
      const menuItem = {
        collapsed: i.collapsed,
        type: i.type || '',
        name: i.title.name || '',
        url: i.title.url || '',
        items: i.items?.map(menuItemsRecursion) || [], // группа!
      }
      if (i.title.font?.color && i.title.font.color !== '#111111') {
        menuItem.color = i.title.font.color;
      }
      return menuItem;
    } else return i;
  });
}

const inDateRange = ({ from, to }) => {
  const now = Date.now();
  from = Date.parse(from);
  to = Date.parse(to);
  return now > from && now < to;
}

const productFormatter = p => { // простой форматтер на наличие для всех типов товаров
  const skus = p?.skus || [];
  const available = p.available && skus.some(s => s.available) && inDateRange(p.active);
  if (!available) {
    // убираем активные размеры и наличие в магазинах
    p.skus = skus.map(({ code, id, size }) => ({ code, id, size, available: false }));
  }
  return {
    ...p,
    available,
  };
};

module.exports = {
  menuFormatter,
  productFormatter,
}
